'use client'
import { FC, ReactNode, useEffect } from 'react'

import { LayoutQuery } from '@/app/graphql/generated'
import {
  FooterComponent,
  HeaderComponent,
  ModalWrapperComponent,
} from '@/app/module/layout/elements'
import useLayout, { ITypeSite } from '@/app/shared/store/layout.store'

// interface
interface ILayoutComponentProps {
  children: ReactNode
  data: LayoutQuery
  typeSite: ITypeSite | null
}

// component
const LayoutComponent: FC<Readonly<ILayoutComponentProps>> = ({ children, data, typeSite }) => {
  const setData = useLayout((state) => state.setData)
  const setTypeSite = useLayout((state) => state.setTypeSite)

  if (typeSite) setTypeSite(typeSite)

  useEffect(() => {
    setData(data)
  }, [data, setData])

  // return
  return (
    <div className={'flex min-h-screen flex-col overflow-x-hidden'}>
      <HeaderComponent typeSite={typeSite} />
      {children}
      <FooterComponent typeSite={typeSite} />
      <ModalWrapperComponent typeSite={typeSite} />
    </div>
  )
}

export default LayoutComponent
